const newArea = {
  snackbar: "Su actualización esta completada",
  name: "Nombre de Planta",
  save: "Guardar",
  cancel: "Cancelar",
  area: "Planta",
  formTitle: "Nueva Planta",
  confirm: "¿Estás seguro de querer eliminar este elemento?",
  close: "Cerrar",
  delete: "Eliminar",
  selectCompany: "Selecciona una Compañía"
};
export default newArea;
